import { PropsWithChildren, ReactElement, useEffect, useState } from 'react'
import { useInjection } from 'inversify-react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { KBLoading } from '@kibsi/ui-components'
import { TenantKibsiClient } from '@kibsi/ks-client-sdk'
import log from 'logging/logger'
import T from 'config/inversify.types'

export function RequireAuth<P>({ children }: PropsWithChildren<P>): ReactElement | null {
    const tenants = useInjection<TenantKibsiClient>(T.TenantApi)
    const { oktaAuth, authState } = useOktaAuth()
    const [ready, setReady] = useState(false)
    const isAuthenticated = authState?.isAuthenticated ?? false

    useEffect(() => {
        if (!authState) {
            // Still loading
            return
        }

        if (!authState.isAuthenticated) {
            oktaAuth.setOriginalUri(toRelativeUrl(window.location.href, window.location.origin))
            oktaAuth.signInWithRedirect().catch((e) => {
                log.error(e)
            })
        } else {
            tenants
                .authCheck()
                .catch(() => {
                    log.debug('auth check failed')
                })
                .finally(() => {
                    // This will make sure the user exists in our system
                    setReady(true)
                })
        }
    }, [tenants, oktaAuth, authState, authState?.isAuthenticated])

    if (authState === null || !ready) {
        return <KBLoading flex={1} loading />
    }

    if (!isAuthenticated) {
        return null
    }

    return <> {children}</>
}
